import InsufficientPermissionsPage from 'components/core/InsufficientPermissionsPage/InsufficientPermissionsPage';
import { isAdmin } from 'shared/domain/role/isAdmin';
import React, { memo } from 'react';
import { useCurrentUserRole } from 'store/user';
import { FieldsSettings } from 'views/fieldsSettings/list';
import { FieldSettings } from 'views/fieldsSettings/single';
import { MemoGenericRoleAuthorizer } from '../GenericRoleAuthorizer';

export const AuthorizableFieldsSettings = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();

    const isCurrentUserAdmin = isAdmin(role);

    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAdmin}
        unauthorized={!isCurrentUserAdmin}
        authorizedComponent={memo(FieldsSettings)}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);

export const AuthorizableFieldSettings = React.memo(
  (): React.ReactElement => {
    const role = useCurrentUserRole();

    const isCurrentUserAdmin = isAdmin(role);

    return (
      <MemoGenericRoleAuthorizer
        authorized={isCurrentUserAdmin}
        unauthorized={!isCurrentUserAdmin}
        authorizedComponent={FieldSettings}
        unauthorizedComponent={InsufficientPermissionsPage}
      />
    );
  }
);
